import MuiMenuItem from '@zenbusiness/zui/MenuItem';
import { styled } from '@zenbusiness/zui/styles';

const MenuItemConnectedAccountStyle = ({ theme }) => ({
  '&.MuiButtonBase-root': {
    ...theme.typography.xs,
    padding: '8px 32px',
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
      padding: '8px 24px',
      ...theme.typography.md,
      fontSize: '14px !important'
    }
  },
  '&.Mui-selected': {
    fontWeight: 600
  },
  '&:hover': {
    backgroundColor: 'rgba(207, 249, 250, 0.4)'
  }
});

export const MenuItemConnectedAccount = styled(MuiMenuItem)(MenuItemConnectedAccountStyle);
